import { Grid } from "@mui/material";
import MetaCard from "./metaCard";
import React from "react";
import { AnalyticsContext } from "../context/analyticsContext";
import { ISearchResults } from "../interface/iSearchResults";

const SearchResults = (): React.JSX.Element => {
  const {
    searchResults,
  }: {
    searchResults: ISearchResults;
  } = React.useContext(AnalyticsContext);

  return (
    <Grid
      container
      spacing={2}
      sx={{
        mt: 2,
      }}
    >
      <Grid item xs={6} sm={4} md={2}>
        <MetaCard
          bgColor="primary.main"
          label="Gesamt"
          value={searchResults.appointmentList?.meta.total}
        />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <MetaCard
          bgColor="success.main"
          label="Aktiv"
          value={searchResults.appointmentList?.meta.active}
        />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <MetaCard
          bgColor="secondary.main"
          label="Durchgeführt"
          value={searchResults.appointmentList?.meta.done}
        />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <MetaCard
          bgColor="info.main"
          label="Frei"
          value={searchResults.appointmentList?.meta.free}
        />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <MetaCard
          bgColor="error.main"
          label="Versäumt"
          value={searchResults.appointmentList?.meta.missed}
        />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <MetaCard
          bgColor="warning.main"
          label="Storniert"
          value={searchResults.appointmentList?.meta.cancelled}
        />
      </Grid>
    </Grid>
  );
};

export default SearchResults;
